/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringcontainsoraspect12Inputs */

const de__class_stringcontainsoraspect12 = /** @type {(inputs: _Class_Stringcontainsoraspect12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beinhaltet eins von`)
};

/**

* @param {_Class_Stringcontainsoraspect12Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringcontainsoraspect12 = /** @type {((inputs?: _Class_Stringcontainsoraspect12Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringcontainsoraspect12Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringcontainsoraspect12(inputs)
});
export { _class_stringcontainsoraspect12 as "_class_StringCONTAINSORAspect" }